export default "__VITE_ASSET__CQ6BAmdv__"